module.exports = __webpack_public_path__ + "img/orange-horizontal.c856863a.png";